import { createApiDescription } from "../../helperFunctions";

export const documentRequestInfo = {
    documentRequest: createApiDescription(
        "SSE APIs to create document.",
        [
            "If retention period is not set we will take your user default.",
            "Default “Notify on Completion” is set to false.",
        ]
    ),
}